import * as buttons from 'smg/buttons';
import { AddCartItems } from 'smg/customer-api/carts';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import { Relref } from '../hugo';
import * as stockitems from '../stockitems';

export default function main() {
    void stockitems.InitPrices(true);
    stockitems.InitGallery();
    stockitems.InitSeeMore();

    const $form = document.querySelector('#stock-item-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $quantity = document.querySelector('#quantity') as HTMLInputElement;
    const $addToCart = document.querySelector('#add-to-cart') as HTMLButtonElement;

    $form.noValidate = true;
    $form.addEventListener('submit', e => {
        e.preventDefault();

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($addToCart);

        AddCartItems({
            stockItemID: 'Ee6S7PEjeyiW3gJCrBIABA', // !!!!
            quantity: parseInt($quantity.value, 10),
        }).then(() => {
            window.location.href = Relref('/cart');
        }).catch(err => {
            $fieldset.disabled = false;
            buttons.Stop($addToCart);
            HandleRequestError(err);
        });
    });
}